/**
 * Menu script
 */
class Menu {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menuBlock = this.menuWrapper.find('.menu');
        this.menuBlockItems = this.menuBlock.find('.menu-item');
    }

    initEvents() {
        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                this.menuBlock.toggleClass('open');
                this.menuIcon.toggleClass('is-active');
                $(document.body).toggleClass('no-scroll');
                this.menuBlock.parent().find('.fixed-social-links').toggleClass('is-active');

                setTimeout(() => {
                    this.menuBlock.toggleClass('is-showing');
                }, 150);
            });

            this.menuBlockItems.on('click', () => {
                this.menuBlock.removeClass('open');
                this.menuIcon.removeClass('is-active');
                this.menuBlock.removeClass('is-showing');
                $(document.body).removeClass('no-scroll');
                this.menuBlock.parent().find('.fixed-social-links').removeClass('is-active');
            })
        }
    }
}
